import {ActionTypes} from "./transaction.types";

const INITIAL_STATE = {
  transactions: undefined
};

const transactionReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case ActionTypes.SET_TRANSACTIONS:
      return {
        ...state,
        transactions: action.payload,
      };
    default:
      return state;
  }
};

export default transactionReducer;